module.exports = __webpack_public_path__ + "static/media/alert_test_selected.35133dec.svg";